import { Typography } from 'antd';
import { FC, useMemo } from 'react';
import { getFieldName } from '../../../../../utils/validationParserUtils';
import { DetailsLabel, DetailsLabelDiv, DetailsValue, StyledErrorRow } from '../DeclarationsNotificationsDrawer.styles';
import { ParsedCard, ParsedItem } from '../../../../../store/declaration-form-errors/ParsedForm';
import { FormikErrors } from 'formik';

const ListErrorsRows: FC<{
    section: string;
    fields: string[];
    handleOnClickField?: (value: string) => void;
    /** Absent while the declaration is still loading, or for a type with no parser of its own. */
    parseDeclaration?: (validation: FormikErrors<any>) => {
        masterDetails: ParsedCard[];
        items: ParsedItem[];
    };
    itemsPath?: string;
    /** Labels a field the way its error card does, naming the item by its number today. */
    getLabel?: (field: string) => string | undefined;
}> = ({ fields, handleOnClickField, section, parseDeclaration, itemsPath, getLabel }) => {
    const constructedFields = useMemo(() => {
        return fields.map((field) => ({
            // Without a parser there is no label to resolve, and the row falls back to the raw path.
            ui: getLabel?.(field) ?? (parseDeclaration ? getFieldName(parseDeclaration, field, itemsPath) : undefined),
            path: field,
        }));
    }, [fields, parseDeclaration, itemsPath, getLabel]);

    return (
        <>
            <StyledErrorRow>
                <DetailsLabelDiv>
                    <DetailsLabel>{section}</DetailsLabel>
                </DetailsLabelDiv>
                <DetailsLabelDiv style={{ flex: 1 }}>
                    {constructedFields.map(({ ui, path }) => {
                        return (
                            <Typography.Link key={ui ?? path} onClick={() => handleOnClickField?.(path)}>
                                <DetailsValue>{`${ui ?? path ?? '-'}`}</DetailsValue>
                            </Typography.Link>
                        );
                    })}
                </DetailsLabelDiv>
            </StyledErrorRow>
        </>
    );
};

export default ListErrorsRows;
